// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import store from './store'
import router from './router'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import './assets/iconfont/iconfont.js'
import echarts from 'echarts'
import uploader from 'vue-simple-uploader'
import Distpicker from 'v-distpicker'
//图片插件
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'



Vue.component('v-distpicker', Distpicker)


Vue.prototype.$echarts = echarts

Vue.config.productionTip = false
Vue.use(Viewer);
Vue.use(uploader)
Vue.use(ElementUI)

Viewer.setDefaults({
  Options: { "inline": true, "button": true, "navbar": true, "title": true, "toolbar": true, "tooltip": true, "movable": true, "zoomable": true, "rotatable": true, "scalable": true, "transition": true, "fullscreen": true, "keyboard": true, "url": "data-source" }
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js